import * as React from 'react';

const InfoIcon = () => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <title>Info</title>
    <desc>Info tooltip icon</desc>
    <g id="Retirement-income---inputs" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Income-calc-inputs---desktop-step2-v3" transform="translate(-658.000000, -769.000000)">
        <g id="choice" transform="translate(-31.000000, 697.000000)">
          <g id="monthly/yearly-copy" transform="translate(394.000000, 30.000000)">
            <g id="Group-3">
              <g id="Group" transform="translate(295.000000, 42.000000)">
                <mask id="mask-2" fill="white">
                  <path d="M10.8,18 L13.2,18 L13.2,10.8 L10.8,10.8 L10.8,18 Z M12,0 C5.376,0 0,5.376 0,12 C0,18.624 5.376,24 12,24 C18.624,24 24,18.624 24,12 C24,5.376 18.624,0 12,0 Z M12,21.6 C6.708,21.6 2.4,17.292 2.4,12 C2.4,6.708 6.708,2.4 12,2.4 C17.292,2.4 21.6,6.708 21.6,12 C21.6,17.292 17.292,21.6 12,21.6 Z M10.8,8.4 L13.2,8.4 L13.2,6 L10.8,6 L10.8,8.4 Z" id="path-1" />
                </mask>
                <path fill="#055a60" fillRule="nonzero" d="M10.8,18 L13.2,18 L13.2,10.8 L10.8,10.8 L10.8,18 Z M12,0 C5.376,0 0,5.376 0,12 C0,18.624 5.376,24 12,24 C18.624,24 24,18.624 24,12 C24,5.376 18.624,0 12,0 Z M12,21.6 C6.708,21.6 2.4,17.292 2.4,12 C2.4,6.708 6.708,2.4 12,2.4 C17.292,2.4 21.6,6.708 21.6,12 C21.6,17.292 17.292,21.6 12,21.6 Z M10.8,8.4 L13.2,8.4 L13.2,6 L10.8,6 L10.8,8.4 Z" id="path-1" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default InfoIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/InfoIcon/InfoIcon.tsx